function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* -------------------------------------------------------
Import Modules
------------------------------------------------------- */

// import VideoController from '../classes/video-embed';

/* -------------------------------------------------------
Document Setup
------------------------------------------------------- */

_toConsumableArray(document.querySelectorAll('.js-tabbed-resources')).forEach(function (block) {
  var tabs = {};
  _toConsumableArray(block.querySelectorAll('input')).forEach(function (tab) {
    // Put this tab in the tabs object
    tabs[tab.id] = {
      tab: tab,
      list: document.getElementById(tab.value)
    };
    tab.addEventListener('change', function () {
      // Loop the tabs object
      Object.keys(tabs).forEach(function (key) {
        var item = tabs[key];

        // if the item.tab is checked, show the item.list
        item.list.classList.toggle('active', item.tab.checked);
      });
    });
  });

  // tabs.forEach((tab) => {
  //   // Find this tab's item
  //   const item = document.getElementById(tab.value);

  //   // If there is no item, skip this tab
  //   if (!item) return;

  //   tab.addEventListener('change', () => {
  //     item.classList.toggle('active', item.checked);
  //   });

  //   // [...item.querySelectorAll('[data-video]')].forEach((video) => {

  //   // });
  // });
});